<script setup lang="ts">
import { onBeforeUnmount, watch } from 'vue'
import { useAuthStore } from '@/store/auth'
import { useNotificationsStore } from '@/store/notifications'
import { RouterLink, RouterView } from 'vue-router'
import NotificationBell from '@/components/NotificationBell.vue'
import NotificationMarquee from '@/components/NotificationMarquee.vue'

const authStore = useAuthStore()
const notifStore = useNotificationsStore()

// 登录状态变化时启停轮询
watch(
  () => authStore.isLoggedIn,
  (v) => {
    if (v) notifStore.startPolling()
    else {
      notifStore.stopPolling()
      notifStore.reset()
    }
  },
  { immediate: true },
)

onBeforeUnmount(() => notifStore.stopPolling())
</script>

<template>
  <div class="min-h-screen bg-gray-50">
    <nav class="bg-blue-600 text-white px-4 py-3 shadow">
      <div class="max-w-6xl mx-auto flex items-center justify-between flex-wrap gap-y-2">
        <h1 class="text-lg font-semibold">资料领用系统</h1>
        <div v-if="authStore.isLoggedIn" class="flex items-center gap-3">
          <RouterLink to="/" class="hover:underline">首页</RouterLink>
          <RouterLink v-if="authStore.isTeacher" to="/materials" class="hover:underline">选书</RouterLink>
          <RouterLink v-if="authStore.isTeacher" to="/reservations" class="hover:underline">预订任务</RouterLink>
          <RouterLink to="/orders" class="hover:underline">{{ authStore.isAdmin ? '订单管理' : '我的订单' }}</RouterLink>
          <RouterLink v-if="authStore.isWarehouseAdmin" to="/warehouse" class="hover:underline">仓管后台</RouterLink>
          <RouterLink v-if="authStore.isSuperAdmin" to="/admin" class="hover:underline">管理后台</RouterLink>
          <NotificationBell />
          <button
            @click="authStore.logout()"
            class="text-sm bg-white/20 px-3 py-1 rounded hover:bg-white/30"
          >
            退出
          </button>
        </div>
      </div>
    </nav>

    <NotificationMarquee />

    <main class="max-w-6xl mx-auto p-4">
      <RouterView />
    </main>
  </div>
</template>
